module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar preparedGalleryImages \t= helpers.detectRenderedImages(model.galleryImages, model._galleryImages, undefined, { width: 800, height: 550 });\nvar nrOfImages \t\t\t\t= utils.collectionSize(preparedGalleryImages);\nif(environment.style === 'mobile' && nrOfImages > 1){\nnrOfImages \t\t\t\t\t\t\t= 1;\nvar firstGalleryImageKey \t\t\t= Object.keys(preparedGalleryImages).shift();\nvar limitedPreparedGalleryImages \t= {};\nlimitedPreparedGalleryImages[firstGalleryImageKey] = preparedGalleryImages[firstGalleryImageKey];\npreparedGalleryImages = limitedPreparedGalleryImages;\n}\nvar isFullScreenGallery = (config.staticLookupName === 'fullScreenGallery');\nvar additionalClasses = [];\nif(!config.active) \t\t\t\tadditionalClasses.push('isHidden');\nif(isFullScreenGallery)\t\t\tadditionalClasses.push(config.staticLookupName);\nif(config.showFrame) \t\t\tadditionalClasses.push('showFrame');\nif(nrOfImages === 1) \t\t\tadditionalClasses.push('singleImageGallery');\nelse if(nrOfImages === 0) \t\tadditionalClasses.push('emptyGallery');\nif(model.isInlineGallery) \t\tadditionalClasses.push('isInlineGallery');\n%>\n<div class=\"<%= additionalClasses.join(' ') %>\">\n<%\nvar initialImageSrc = \"\";\nvar imageList = \"\";\n// image(s) given\nif (!utils.isEmpty(preparedGalleryImages)){\nvar firstImg = true;\nvar isActive = false;\nvar image, imageIndex;\n// a list of images results in an carousel\nfor(imageIndex in preparedGalleryImages){\nimage = preparedGalleryImages[imageIndex] || {};\nif(!isFullScreenGallery){\nimage = image.rendered || {};\n}\n// set source for initial big image\nisActive = false;\nif (firstImg || model.activeMediaIndex == imageIndex) {\nisActive = true;\ninitialImageSrc = image.url;\n}\n// build list of all images in gallery\nimageList += '<div class=\"thumb' + (isActive ? ' active' : '') + '\" data-media-id=\"' + image.mediaID + '\">';\nimageList += '  <div style=\"background-image:url(' + image.url + ')\" title=\"' + image.title +'\" alt=\"' + image.alt +'\"></div>';\nimageList += '</div>';\n// first image done\nfirstImg = false;\n}\n}\nif(model.title) {\n%><h2><%= model.title %></h2><%\n}\nif (!utils.isEmpty(preparedGalleryImages)){\n%>\n<div class=\"background\"></div>\n<div class=\"frame<%= (model.title ? ' frameWithHeadline' : '') %>\">\n<%\nif(isFullScreenGallery){\n%>\n<div class=\"image\">\n<img src=\"<%= initialImageSrc %>\">\n<%\n} else {\n%><div class=\"image\" style=\"background-image:url(<%= initialImageSrc %>);\"><%\n}\n%>\n<div class=\"left\">\n<%\nif(config.showArrows && nrOfImages > 1){\n%>\n<div class=\"arrow\">\n<div class=\"background\">&nbsp;</div>\n<div class=\"content\"><i class=\"fi fi-arrow-left\"></i></div>\n</div>\n<%\n}\n%>\n</div>\n<div class=\"center\">\n<%\nif(config.showFullScreen){\n%><div class=\"fullScreen\"></div><%\n}\n%>\n</div>\n<div class=\"right\">\n<%\nif(isFullScreenGallery){\n%><div class=\"close\"></div><%\n}\nif(config.showArrows && nrOfImages > 1){\n%>\n<div class=\"arrow\">\n<div class=\"background\">&nbsp;</div>\n<div class=\"content\"><i class=\"fi fi-arrow-right\"></i></div>\n</div>\n<%\n}\n%>\n</div>\n</div>\n<div class=\"imageList\">\n<%- imageList %>\n</div>\n</div>\n<%\n}\nif(environment.style !== 'mobile' && !model.isInlineGallery && (model.phone || model.shortDescription || model.expose)) {\n%><%- include('./rightSideBar', { model: model }) %><%\n}\n%>\n</div>"
  , __filename = "components/templates/project/gallery/gallery.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var preparedGalleryImages 	= helpers.detectRenderedImages(model.galleryImages, model._galleryImages, undefined, { width: 800, height: 550 });
var nrOfImages 				= utils.collectionSize(preparedGalleryImages);
if(environment.style === 'mobile' && nrOfImages > 1){
nrOfImages 							= 1;
var firstGalleryImageKey 			= Object.keys(preparedGalleryImages).shift();
var limitedPreparedGalleryImages 	= {};
limitedPreparedGalleryImages[firstGalleryImageKey] = preparedGalleryImages[firstGalleryImageKey];
preparedGalleryImages = limitedPreparedGalleryImages;
}
var isFullScreenGallery = (config.staticLookupName === 'fullScreenGallery');
var additionalClasses = [];
if(!config.active) 				additionalClasses.push('isHidden');
if(isFullScreenGallery)			additionalClasses.push(config.staticLookupName);
if(config.showFrame) 			additionalClasses.push('showFrame');
if(nrOfImages === 1) 			additionalClasses.push('singleImageGallery');
else if(nrOfImages === 0) 		additionalClasses.push('emptyGallery');
if(model.isInlineGallery) 		additionalClasses.push('isInlineGallery');

    ; __line = 19
    ; __append("\n<div class=\"")
    ; __line = 20
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n")
    ; __line = 21
    ; 
var initialImageSrc = "";
var imageList = "";
// image(s) given
if (!utils.isEmpty(preparedGalleryImages)){
var firstImg = true;
var isActive = false;
var image, imageIndex;
// a list of images results in an carousel
for(imageIndex in preparedGalleryImages){
image = preparedGalleryImages[imageIndex] || {};
if(!isFullScreenGallery){
image = image.rendered || {};
}
// set source for initial big image
isActive = false;
if (firstImg || model.activeMediaIndex == imageIndex) {
isActive = true;
initialImageSrc = image.url;
}
// build list of all images in gallery
imageList += '<div class="thumb' + (isActive ? ' active' : '') + '" data-media-id="' + image.mediaID + '">';
imageList += '  <div style="background-image:url(' + image.url + ')" title="' + image.title +'" alt="' + image.alt +'"></div>';
imageList += '</div>';
// first image done
firstImg = false;
}
}
if(model.title) {

    ; __line = 50
    ; __append("<h2>")
    ; __append(escapeFn( model.title ))
    ; __append("</h2>")
    ; 
}
if (!utils.isEmpty(preparedGalleryImages)){

    ; __line = 53
    ; __append("\n<div class=\"background\"></div>\n<div class=\"frame")
    ; __line = 55
    ; __append(escapeFn( (model.title ? ' frameWithHeadline' : '') ))
    ; __append("\">\n")
    ; __line = 56
    ; 
if(isFullScreenGallery){

    ; __line = 58
    ; __append("\n<div class=\"image\">\n<img src=\"")
    ; __line = 60
    ; __append(escapeFn( initialImageSrc ))
    ; __append("\">\n")
    ; __line = 61
    ; 
} else {

    ; __line = 63
    ; __append("<div class=\"image\" style=\"background-image:url(")
    ; __append(escapeFn( initialImageSrc ))
    ; __append(");\">")
    ; 
}

    ; __line = 65
    ; __append("\n<div class=\"left\">\n")
    ; __line = 67
    ; 
if(config.showArrows && nrOfImages > 1){

    ; __line = 69
    ; __append("\n<div class=\"arrow\">\n<div class=\"background\">&nbsp;</div>\n<div class=\"content\"><i class=\"fi fi-arrow-left\"></i></div>\n</div>\n")
    ; __line = 74
    ; 
}

    ; __line = 76
    ; __append("\n</div>\n<div class=\"center\">\n")
    ; __line = 79
    ; 
if(config.showFullScreen){

    ; __line = 81
    ; __append("<div class=\"fullScreen\"></div>")
    ; 
}

    ; __line = 83
    ; __append("\n</div>\n<div class=\"right\">\n")
    ; __line = 86
    ; 
if(isFullScreenGallery){

    ; __line = 88
    ; __append("<div class=\"close\"></div>")
    ; 
}
if(config.showArrows && nrOfImages > 1){

    ; __line = 91
    ; __append("\n<div class=\"arrow\">\n<div class=\"background\">&nbsp;</div>\n<div class=\"content\"><i class=\"fi fi-arrow-right\"></i></div>\n</div>\n")
    ; __line = 96
    ; 
}

    ; __line = 98
    ; __append("\n</div>\n</div>\n<div class=\"imageList\">\n")
    ; __line = 102
    ; __append( imageList )
    ; __append("\n</div>\n</div>\n")
    ; __line = 105
    ; 
}
if(environment.style !== 'mobile' && !model.isInlineGallery && (model.phone || model.shortDescription || model.expose)) {

    ; __line = 108
    ; __append( include('./rightSideBar', { model: model }) )
    ; 
}

    ; __line = 110
    ; __append("\n</div>")
    ; __line = 111
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/project/gallery/gallery.ejs

}